var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1RightArrowD(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56.23L46.4 38 28 19.77 30.8 17 52 38 30.8 59 28 56.23z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Right_arrow_D.0a054c29.svg";
export { SvgJ1RightArrowD as ReactComponent };